export enum CheetahIconPack {
  AI = 'AI',
  CALENDAR = 'CALENDAR',
  CCTV = 'CCTV',
  CLOCK = 'CLOCK',
  COMMENT = 'COMMENT',
  DOCTOR = 'DOCTOR',
  DOCTOR_SMALL = 'DOCTOR_SMALL',
  DOWNLOAD = 'DOWNLOAD',
  EYE = 'EYE',
  HOSPITAL_ASSESSMENT_CERTIFIED = 'HOSPITAL_ASSESSMENT_CERTIFIED',
  MONEY = 'MONEY',
  NEW_BADGE = 'NEW_BADGE',
  REALMODEL = 'REALMODEL',
  RECEIPT_CERTIFIED = 'RECEIPT_CERTIFIED',
  RESERVATION = 'RESERVATION',
  SMILE = 'SMILE',
  STAR = 'STAR',
  SUB_ARROW = 'SUB_ARROW',
  THUMB_UP = 'THUMB_UP',
  TREATMENT_SUMMARY_CONCERN = 'TREATMENT_SUMMARY_CONCERN',
  TREATMENT_SUMMARY_CYCLES = 'TREATMENT_SUMMARY_CYCLES',
  TREATMENT_SUMMARY_NUMBERS = 'TREATMENT_SUMMARY_NUMBERS',
  TREATMENT_SUMMARY_TIMES = 'TREATMENT_SUMMARY_TIMES',
  FLAG_CIRCLE_KR = 'FLAG_CIRCLE_KR',
  FLAG_CIRCLE_JP = 'FLAG_CIRCLE_JP',
  MULTIPLE_PHOTOS = 'MULTIPLE_PHOTOS',
  NAVBAR_COLUMN_ON = 'NAVBAR_COLUMN_ON',
  NAVBAR_COLUMN_OFF = 'NAVBAR_COLUMN_OFF',
  WRITE = 'WRITE',
  NOTICE = 'NOTICE',
  TELEPHONE = 'TELEPHONE',
  BEST_CATEGORY = 'BEST_CATEGORY',
  ASK_DOCTOR_CATEGORY = 'ASK_DOCTOR_CATEGORY',
  FREE_TALK_CATEGORY = 'FREE_TALK_CATEGORY',
  HOSPITAL_QUESTION_CATEGORY = 'HOSPITAL_QUESTION_CATEGORY',
  PLASTIC_SURGERY_QUESTION_CATEGORY = 'PLASTIC_SURGERY_QUESTION_CATEGORY',
  REVIEWS_CATEGORY = 'REVIEWS_CATEGORY',
  MEDICAL_TIP = 'MEDICAL_TIP',
  DOCTOR_CATEGORY = 'DOCTOR_CATEGORY',
  REGION_CATEGORY = 'REGION_CATEGORY',
  LOCKED = 'LOCKED',
  VIEWS = 'VIEWS',
}
